import { useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'
import type { TrackTitleSuggestion } from '../api/suno'
import { useToast } from '../components/ToastProvider'
import { ToolDetailHeader } from '../features/suno/ToolDetailHeader'
import { TrackTitleWorkspace } from '../features/suno/TrackTitleGenerator/TrackTitleWorkspace'
import { useTrackTitleGeneratorData } from '../features/suno/TrackTitleGenerator/useTrackTitleGeneratorData'
import type { AdminOutletContext } from '../layouts/AdminLayout'

export const TrackTitleGeneratorPage = () => {
  const { toast } = useToast()
  const { setMobileMenuItems } = useOutletContext<AdminOutletContext>()
  const {
    artist,
    setArtist,
    stylePrompt,
    setStylePrompt,
    language,
    languageMenuOpen,
    setLanguageMenuOpen,
    suggestions,
    error,
    loading,
    promptValid,
    selectedLanguageLabel,
    selectLanguage,
    submitTrackTitles
  } = useTrackTitleGeneratorData()

  useEffect(() => {
    setMobileMenuItems(null)
  }, [setMobileMenuItems])

  const copyText = async (value: string, label: string): Promise<void> => {
    await navigator.clipboard.writeText(value)
    toast(`Copied ${label}.`)
  }

  const copyTitleSuggestion = async (suggestion: TrackTitleSuggestion): Promise<void> => {
    await copyText(suggestion.text, `"${suggestion.text}"`)
  }

  return (
    <>
      <ToolDetailHeader
        subtitle="Generate release-ready names from a Suno style prompt."
        title="Track Name Generator"
      />

      <TrackTitleWorkspace
        artist={artist}
        error={error}
        language={language}
        languageMenuOpen={languageMenuOpen}
        loading={loading}
        onArtistChange={setArtist}
        onCopySuggestion={(suggestion) => void copyTitleSuggestion(suggestion)}
        onLanguageMenuToggle={() => setLanguageMenuOpen((isOpen) => !isOpen)}
        onSelectLanguage={selectLanguage}
        onStylePromptChange={setStylePrompt}
        onSubmit={submitTrackTitles}
        promptValid={promptValid}
        selectedLanguageLabel={selectedLanguageLabel}
        stylePrompt={stylePrompt}
        suggestions={suggestions}
      />
    </>
  )
}
